import { SchemaWidgetInstance } from "../SchemaWidgetClass";
import { postalAddressJson } from "./postalAddressJsonLd";

export const jobPostingJson = (data: SchemaWidgetInstance, page: unknown) => {
  const datePosted = data.get("datePosted");

  const jobPostingJsonLd = {
    "@context": "https://schema.org",
    "@type": "JobPosting",
    name: data.get("name"),
    description: data.get("description"),
    title: data.get("jobTitle"),
    datePosted: datePosted,
    employmentType:
      data.get("employmentType") === "OTHER"
        ? data.get("employmentTypeOther")
        : data.get("employmentType"),
    hiringOrganization: {
      "@type": "Organization",
      name: data.get("organizationName"),
      url: data.get("url"),
    },
    baseSalary: {
      "@type": "MonetaryAmount",
      currency: "EUR",
      value: {
        "@type": "QuantitativeValue",
        value: data.get("baseSalary"),
        unitText: "MONTHLY",
      },
    },
    validThrough: data.get("validThrough"),
    jobLocation: {
      "@type": "Place",
      address: postalAddressJson(data, page),
    },
  };

  return jobPostingJsonLd;
};
